import { DataTableColumn } from "../Common/DataTable/DataTable";
import { useSnackbar } from "notistack";
import React from "react";
import { ValueType } from "@interfaces/ValueType";
import { ServiceHelper } from "@modules";
import { vTypesService } from "@services";
import { DataTable } from "../Common";
import { useCurrentPageInfo, useModal } from "@hooks";
import useContextHelp from "@hooks/useContextHelp";

const ValueTypesTable = () => {
    const { permission } = useCurrentPageInfo();
    const { onContextClickHandler } = useContextHelp({});
    const { handleOpenModal } = useModal();
    const { enqueueSnackbar } = useSnackbar();

    const handleEditClick = async (rowData) => {
        try {
            await vTypesService.setValueTypeBlock(rowData.id);
            handleOpenModal("EDIT_VALUE_TYPE", { itemId: rowData.id });
        } catch (err) {
            const message = err.response?.data.error_tooltip;
            enqueueSnackbar(message, {
                variant: "info",
            });
        }
    };

    const handleDeleteClick = async (rowData: ValueType | ValueType[]) => {
        try {
            const ids = ServiceHelper.getIdsListFromRowDataObject(rowData);
            await vTypesService.deleteValueType(ids);
            enqueueSnackbar("Тип значения успешно удален", {
                variant: "success",
            });
        } catch (err) {
            const message = err.response.data.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при удалении типа значения", {
                variant: "error",
            });
        }
    };

    const handleContextHelpClick = (e, rowData) => {
        onContextClickHandler(e, "value_types_id", rowData.id);
    };

    const columns: DataTableColumn<ValueType>[] = [
        {
            title: "#",
            field: "id",
            width: 50,
            defaultSort: "asc",
        },
        {
            title: "Наименование",
            field: "name",
            width: "auto",
        },
        {
            title: "Комментарий",
            field: "notes",
            width: "auto",
        },
        {
            title: "Тип данных",
            field: "phys_col",
            width: "auto",
        },
    ];

    return (
        <DataTable
            title="Типы значений"
            fetchFn={vTypesService.getValueTypes}
            columns={columns}
            displayField="name"
            selection
            sorting
            permission={permission}
            search
            onEditClick={handleEditClick}
            onDeleteClick={handleDeleteClick}
            onMassDeleteClick={handleDeleteClick}
            customActions={[
                {
                    name: "context_help",
                    icon: "help_outline",
                    iconProps: {
                        fontSize: "small",
                    },
                    position: "row",
                    tooltip: "Контекстная справка",
                    onClick: handleContextHelpClick,
                },
            ]}
        />
    );
};

export default ValueTypesTable;
